|
<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="ciclo-escolar" titulo="Ciclo Escolar / Coordinación Académica" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh;">
                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <!-- <a id="catalogos" (click)="ctrl.cargarCatalogo('niveles_educativos', 'nivel-educativo');"></a>
                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label class="label">Nivel Educativo:</label>
                                <ng-select2 [disabled]="ctrl.niveles_educativos ? ctrl.niveles_educativos.length == 0 ? true : false : true" name="niveles_educativos_id" [options]="ctrl.optionSelect" (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.niveles_educativos_id)"
                                    [value]="ctrl.dato.controls.niveles_educativos_id.value" [data]="ctrl.niveles_educativos"></ng-select2>
                            </div>
                        </div>
                    </div> -->

                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <label class="label">Fecha inicio:</label>
                                <p class="control has-icons-left has-icons-right">
                                    <input class="input" formControlName="fecha_inicio" type="date" [attr.min]="ctrl.dato.get('fecha_inicio').value" [ngClass]="{'is-danger': ctrl.dato.get('fecha_inicio').hasError('required')}" />
                                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('fecha_inicio').hasError('required')">
                        <i class="fa fa-warning"></i>
                    </span>
                                    <span class="help is-danger" *ngIf="ctrl.dato.get('fecha_inicio').hasError('required')">Este campo es requerido.</span>
                                </p>
                            </div>
                        </div>

                        <div class="column">
                            <div class="field">
                                <label class="label">Fecha fin:</label>
                                <p class="control has-icons-left has-icons-right">
                                    <input class="input" formControlName="fecha_fin" type="date" [attr.min]="ctrl.dato.get('fecha_fin').value" [ngClass]="{'is-danger': ctrl.dato.get('fecha_fin').hasError('required')}" />
                                    <span class="icon is-small is-right" *ngIf="ctrl.dato.get('fecha_fin').hasError('required')">
                        <i class="fa fa-warning"></i>
                    </span>
                                    <span class="help is-danger" *ngIf="ctrl.dato.get('fecha_fin').hasError('required')">Este campo es requerido.</span>
                                </p>
                            </div>
                        </div>
                    </div>

                </section>
            </form>
        </div>
    </div>
</div>